import React, { ReactNode } from "react";
import styled from "styled-components/macro";

const $ContainerWrapper = styled.div`
  flex: 1;
`;

const $Container = styled.div`
  max-width: 35rem;
  padding: 0.5rem;
`;

interface Props {
  children: ReactNode;
  className?: string;
}

export default function OnboardingPageContainer({
  children,
  className,
}: Props) {
  // TODO may add a Logout button, to confirm with design
  // TODO may add a Help button, to confirm with design
  return (
    <$ContainerWrapper
      className={`d-flex flex-column align-items-center ${className}`}
    >
      <$Container className="mt-5">{children}</$Container>
    </$ContainerWrapper>
  );
}
